/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for adding a problem to a workshop.
 * @export
 * @interface WorkshopProblemAdd
 */
export interface WorkshopProblemAdd {
    /**
     * 
     * @type {string}
     * @memberof WorkshopProblemAdd
     */
    problem_id: string;
    /**
     * 
     * @type {number}
     * @memberof WorkshopProblemAdd
     */
    order?: number | null;
}

/**
 * Check if a given object implements the WorkshopProblemAdd interface.
 */
export function instanceOfWorkshopProblemAdd(value: object): value is WorkshopProblemAdd {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    return true;
}

export function WorkshopProblemAddFromJSON(json: any): WorkshopProblemAdd {
    return WorkshopProblemAddFromJSONTyped(json, false);
}

export function WorkshopProblemAddFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopProblemAdd {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function WorkshopProblemAddToJSON(json: any): WorkshopProblemAdd {
    return WorkshopProblemAddToJSONTyped(json, false);
}

export function WorkshopProblemAddToJSONTyped(value?: WorkshopProblemAdd | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'order': value['order'],
    };
}

